import styled from "styled-components";

export const DisplayRow = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing.xSmall,
}));
